<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{ $t('user.create.subtitle') }}
        </span>
        <h3 class="page-title">
          {{ $t('user.create.title') }}
        </h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <user-account-details />
  </d-container>
</template>

<script>
import Events from '_utils/events';
import UserAccountDetails from '_modules/user/components/UserAccountDetails.vue';

export default {
  name: 'user-create',
  components: {
    UserAccountDetails,
  },
  computed: {},
  data() {
    return {};
  },
  created() {
    Events.$emit('sidebarVisible', false);
  },
};
</script>
